__turbopack_context__.v({
  "extraWide": "Header-module-scss-module__JJFXqa__extraWide",
  "header": "Header-module-scss-module__JJFXqa__header",
  "highlit": "Header-module-scss-module__JJFXqa__highlit",
  "masthead": "Header-module-scss-module__JJFXqa__masthead",
  "navbarLong": "Header-module-scss-module__JJFXqa__navbarLong",
  "navbarShort": "Header-module-scss-module__JJFXqa__navbarShort",
  "selected": "Header-module-scss-module__JJFXqa__selected",
  "sitelogo": "Header-module-scss-module__JJFXqa__sitelogo",
  "topBar": "Header-module-scss-module__JJFXqa__topBar",
});
